import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import classes from './styles.module.scss';

export default function SectionNavigator({
  sections,
  activeSection,
  setActiveSection,
  translationPath,
  getSectionStatus,
}) {
  const { t } = useTranslation();

  return (
    <div className={classes.SectionNavigator}>
      {sections.map((section) => {
        const status = getSectionStatus
          ? getSectionStatus(section)
          : 'incomplete';
        const isActive = activeSection === section;

        return (
          <button
            key={section}
            type="button"
            onClick={() => setActiveSection(section)}
            className={classNames(classes.pill, {
              [classes.active]: isActive,
              [classes.incomplete]: status === 'incomplete',
              [classes.pending]: status === 'pending',
              [classes.complete]: status === 'complete',
              [classes.error]: status === 'error',
            })}
          >
            {t(`${translationPath}.${section}`)}
          </button>
        );
      })}
    </div>
  );
}
